// @core/api/endpoints/workflow/resume_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineResponse,
  ResumePipelineRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Resume pipeline
 * Resumes a paused pipeline. Scheduled triggers and event listeners are re-enabled.
 */
export async function ResumePipeline(
  pipeline_id: string,
  data: ResumePipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/resume`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
